<script>
  export let title;
  export let image;
  export let price;
  let selected;

	import { budget } from '../../stores.js';

  function handeClick() {
    price = Number.parseInt(price, 10);
    selected = !selected
    budget.update(n => n + (selected ? price : price * -1))
  }
</script>

<style>
  .widget {
    padding: 4px;
    margin: 4px;
  }
  .selected {
    background-color: #33a6ff;
    color: white;
  }
</style>

<div on:click={handeClick} class="widget {selected === true ? 'selected' : ''}">
  <div>{title}</div>
  <img src={image} alt="Android phone" width="320px" height="240px" />
</div>
